/* Bellani product page (owner: Product agent). Plain ES2019, no dependencies.
   - Gallery: thumbnails scroll the snap track, track scroll updates the active thumb,
     arrow keys move between photos.
   - Variants: radio pills pick a variant, then update hidden id, price, button state,
     URL (?variant=) and media. Fires a change event on the id input for Subi.
   - Quantity stepper and the button total (uses the selling plan price when one is chosen).
   - Native selling plan fallback, only when Subi is not detected.
   - "Pairs well with": product recommendations via the Section Rendering endpoint.
   Add to cart submit itself is handled by bp-cart.js (contract #2). */
(function () {
  'use strict';
  if (window.__bpProductJs) return;
  window.__bpProductJs = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || '${{amount}}';
    function delimit(number, precision, thousands, decimal) {
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      // Match money_without_trailing_zeros: drop ".00"
      if (parts[1] && /^0+$/.test(parts[1])) frac = '';
      return whole + frac;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return delimit(cents, 2, ',', '.');
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function decodeFormat(str) {
    var t = document.createElement('textarea');
    t.innerHTML = str || '';
    return t.value;
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-bp-gallery-track]');
    if (!track) return null;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-bp-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-bp-thumb]'));
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      slides.forEach(function (s, n) {
        if (n !== i) {
          var v = s.querySelector('video');
          if (v && !v.paused) v.pause();
        }
      });
    }

    function goTo(i) {
      if (i < 0 || i >= slides.length) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      setActive(i);
    }

    function goToMedia(id) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(id)) { goTo(i); return; }
      }
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i); });
    });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(slides.length - 1, current + 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, current - 1)); }
    });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = null;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== current && i >= 0 && i < slides.length) setActive(i);
      });
    }, { passive: true });

    return { goToMedia: goToMedia };
  }

  /* ---------- Product form ---------- */
  function initProduct(root) {
    if (root.__bpInit) return;
    root.__bpInit = true;

    var moneyFormat = decodeFormat(root.getAttribute('data-money-format'));
    var variants = [];
    var dataEl = root.querySelector('[data-bp-product-variants]');
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }

    var gallery = initGallery(root);
    var form = root.querySelector('form[data-bp-add-to-cart]');
    var idInput = root.querySelector('[data-bp-variant-id]');
    var picker = root.querySelector('[data-bp-variant-picker]');
    var atc = root.querySelector('[data-bp-atc]');
    var atcText = root.querySelector('[data-bp-atc-text]');
    var atcTotal = root.querySelector('[data-bp-atc-total]');
    var priceNow = root.querySelector('[data-bp-price-now]');
    var priceWas = root.querySelector('[data-bp-price-was]');
    var priceWasValue = root.querySelector('[data-bp-price-was-value]');
    var priceLabel = root.querySelector('[data-bp-price-label]');
    var qtyInput = root.querySelector('[data-bp-qty-input]');

    var currentVariant = null;
    if (idInput) {
      var startId = parseInt(idInput.value, 10);
      currentVariant = variants.filter(function (v) { return v.id === startId; })[0] || variants[0] || null;
    }

    function qty() {
      var n = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return isNaN(n) || n < 1 ? 1 : n;
    }

    function sellingPlanId() {
      if (!form) return '';
      var fields = form.querySelectorAll('[name="selling_plan"]');
      for (var i = 0; i < fields.length; i++) {
        var f = fields[i];
        if (f.disabled) continue;
        if ((f.type === 'radio' || f.type === 'checkbox') && !f.checked) continue;
        if (f.value) return f.value;
      }
      return '';
    }

    function unitPrice(v) {
      if (!v) return 0;
      var plan = sellingPlanId();
      if (plan && v.selling_plan_allocations) {
        for (var i = 0; i < v.selling_plan_allocations.length; i++) {
          var a = v.selling_plan_allocations[i];
          if (String(a.selling_plan_id) === String(plan)) return a.price;
        }
      }
      return v.price;
    }

    function renderTotal() {
      if (!atcTotal || !currentVariant) return;
      var next = ' · ' + formatMoney(unitPrice(currentVariant) * qty(), moneyFormat);
      if (atcTotal.textContent !== next) atcTotal.textContent = next;
    }

    function renderVariant(v) {
      if (!atc) return;
      if (!v) {
        atc.disabled = true;
        if (atcText) atcText.textContent = atc.getAttribute('data-label-unavailable') || 'Unavailable';
        if (atcTotal) atcTotal.hidden = true;
        return;
      }
      if (priceNow) priceNow.textContent = formatMoney(v.price, moneyFormat);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (priceWas) priceWas.hidden = !onSale;
      if (priceWasValue && onSale) priceWasValue.textContent = formatMoney(v.compare_at_price, moneyFormat);
      if (priceLabel) priceLabel.textContent = onSale ? 'Sale price' : 'Price';

      atc.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? atc.getAttribute('data-label-add') : atc.getAttribute('data-label-soldout');
      if (atcTotal) atcTotal.hidden = !v.available;
      renderTotal();
    }

    function updateOptionAvailability() {
      if (!picker || !currentVariant) return;
      var groups = picker.querySelectorAll('fieldset');
      var selected = currentVariant.options.slice();
      Array.prototype.forEach.call(groups, function (group, gi) {
        Array.prototype.forEach.call(group.querySelectorAll('input[type="radio"]'), function (input) {
          var test = selected.slice();
          test[gi] = input.value;
          var match = variants.filter(function (v) {
            return v.options.every(function (o, k) { return o === test[k]; });
          })[0];
          var ok = !!(match && match.available);
          var wrap = input.parentNode;
          if (wrap) wrap.classList.toggle('is-unavailable', !ok);
          var note = wrap ? wrap.querySelector('[data-bp-soldout-note]') : null;
          if (note) note.textContent = ok ? '' : (match ? ', sold out' : ', unavailable');
        });
      });
    }

    function onOptionChange() {
      var groups = picker.querySelectorAll('fieldset');
      var chosen = Array.prototype.map.call(groups, function (g) {
        var c = g.querySelector('input[type="radio"]:checked');
        return c ? c.value : null;
      });
      var v = variants.filter(function (x) {
        return x.options.every(function (o, k) { return o === chosen[k]; });
      })[0] || null;
      currentVariant = v;
      renderVariant(v);
      if (!v) return;

      if (idInput) {
        idInput.value = v.id;
        // Subi and other apps watch the variant id input
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateOptionAvailability();
      if (v.featured_media && gallery) gallery.goToMedia(v.featured_media.id);

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }

      root.dispatchEvent(new CustomEvent('bp:variant:change', { bubbles: true, detail: { variant: v } }));
    }

    if (picker) {
      picker.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'radio') onOptionChange();
      });
      updateOptionAvailability();
    }

    /* Quantity stepper */
    var minus = root.querySelector('[data-bp-qty-minus]');
    var plus = root.querySelector('[data-bp-qty-plus]');
    function setQty(n) {
      if (!qtyInput) return;
      var min = parseInt(qtyInput.min, 10) || 1;
      var max = parseInt(qtyInput.max, 10) || 99;
      n = Math.max(min, Math.min(max, n));
      qtyInput.value = n;
      if (minus) minus.disabled = n <= min;
      if (plus) plus.disabled = n >= max;
      renderTotal();
    }
    if (qtyInput) {
      if (minus) minus.addEventListener('click', function () { setQty(qty() - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(qty() + 1); });
      qtyInput.addEventListener('change', function () { setQty(qty()); });
      qtyInput.addEventListener('input', renderTotal);
      setQty(qty());
    }

    /* Selling plan changes (Subi or native) update the button total */
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target && e.target.getAttribute('name') === 'selling_plan') renderTotal();
      });
      form.addEventListener('click', function () {
        window.setTimeout(renderTotal, 60);
        window.setTimeout(renderTotal, 350);
      });
      /* Subi renders after load and may preselect a plan: re-check once it appears */
      [600, 1500, 3000].forEach(function (ms) { window.setTimeout(renderTotal, ms); });
      if (window.MutationObserver) {
        var totalTimer = null;
        new MutationObserver(function () {
          window.clearTimeout(totalTimer);
          totalTimer = window.setTimeout(renderTotal, 80);
        }).observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'checked', 'class'] });
      }
    }

    initNativePlans(root, form, renderTotal);
  }

  /* ---------- Native selling plan fallback (only without Subi) ---------- */
  function subiPresent(form) {
    if (!form) return false;
    if (form.querySelector('[name="selling_plan"]:not([data-bp-native-plan])')) return true;
    var nodes = form.querySelectorAll('[class*="subi" i], [id*="subi" i], [data-subi]');
    for (var i = 0; i < nodes.length; i++) {
      // Ignore our own slot and fallback markup
      if (!nodes[i].closest('[data-bp-native-plans]') && !nodes[i].hasAttribute('data-bp-subi-slot')) return true;
    }
    if (document.querySelector('[id*="subi" i][id*="widget" i], [class*="subi-widget" i]')) return true;
    return false;
  }

  function initNativePlans(root, form, onChange) {
    var box = root.querySelector('[data-bp-native-plans]');
    if (!box || !form) return;
    var hidden = box.querySelector('[data-bp-native-plan]');
    var choices = box.querySelectorAll('[data-bp-plan-choice]');

    function sync() {
      var picked = box.querySelector('[data-bp-plan-choice]:checked');
      hidden.value = picked ? picked.value : '';
      hidden.disabled = !hidden.value;
      onChange();
    }

    function activate() {
      if (subiPresent(form)) return;
      box.hidden = false;
      Array.prototype.forEach.call(choices, function (c) { c.addEventListener('change', sync); });
      sync();
    }

    var tries = 0;
    function check() {
      if (subiPresent(form)) return; // Subi took over, keep fallback hidden and disabled
      tries += 1;
      if (tries >= 6) { activate(); return; }
      window.setTimeout(check, 500);
    }
    if (document.readyState === 'complete') check();
    else window.addEventListener('load', check);
  }

  /* ---------- Recommendations ---------- */
  function initPairs(el) {
    if (el.__bpInit) return;
    el.__bpInit = true;
    var intent = el.getAttribute('data-intent');
    var base = el.getAttribute('data-url');
    if (!base || intent === 'none' || !window.fetch || !window.DOMParser) return;
    var allowRelated = el.getAttribute('data-related-fallback') === 'true';

    function load(which) {
      return fetch(base + '&intent=' + encodeURIComponent(which), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-bp-pairs]');
          if (!fresh) return false;
          var count = parseInt(fresh.getAttribute('data-count'), 10) || 0;
          if (count === 0) return false;
          el.innerHTML = fresh.innerHTML;
          el.classList.remove('is-empty');
          el.setAttribute('data-count', String(count));
          document.dispatchEvent(new CustomEvent('bp:pairs:loaded', { detail: { element: el } }));
          return true;
        });
    }

    function run() {
      load(intent).then(function (ok) {
        if (!ok && intent === 'complementary' && allowRelated) return load('related');
        return ok;
      }).catch(function () { /* keep the fallback list */ });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); run(); }
      }, { rootMargin: '600px 0px' });
      io.observe(el);
    } else {
      run();
    }
  }

  function initAll(scope) {
    var s = scope || document;
    Array.prototype.forEach.call(s.querySelectorAll('[data-bp-product]'), initProduct);
    Array.prototype.forEach.call(s.querySelectorAll('[data-bp-pairs]'), initPairs);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
